var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgFilledFeedbackWarning = function SvgFilledFeedbackWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 98,
    viewBox: "0 0 192 98",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 9,
    width: 80,
    height: 80,
    rx: 24,
    fill: "#FFF6C9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96 31c-9.941 0-18 8.059-18 18s8.059 18 18 18 18-8.059 18-18-8.059-18-18-18zM74 49c0-12.15 9.85-22 22-22s22 9.85 22 22-9.85 22-22 22-22-9.85-22-22zm22-10a2 2 0 012 2v8a2 2 0 11-4 0v-8a2 2 0 012-2zm-2 18a2 2 0 012-2h.02a2 2 0 110 4H96a2 2 0 01-2-2z",
    fill: "#E58303"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkyIiBoZWlnaHQ9Ijk4IiB2aWV3Qm94PSIwIDAgMTkyIDk4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB4PSI1NiIgeT0iOSIgd2lkdGg9IjgwIiBoZWlnaHQ9IjgwIiByeD0iMjQiIGZpbGw9IiNGRkY2QzkiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05NiAzMUM4Ni4wNTg5IDMxIDc4IDM5LjA1ODkgNzggNDlDNzggNTguOTQxMSA4Ni4wNTg5IDY3IDk2IDY3QzEwNS45NDEgNjcgMTE0IDU4Ljk0MTEgMTE0IDQ5QzExNCAzOS4wNTg5IDEwNS45NDEgMzEgOTYgMzFaTTc0IDQ5Qzc0IDM2Ljg0OTcgODMuODQ5NyAyNyA5NiAyN0MxMDguMTUgMjcgMTE4IDM2Ljg0OTcgMTE4IDQ5QzExOCA2MS4xNTAzIDEwOC4xNSA3MSA5NiA3MUM4My44NDk3IDcxIDc0IDYxLjE1MDMgNzQgNDlaTTk2IDM5Qzk3LjEwNDYgMzkgOTggMzkuODk1NCA5OCA0MVY0OUM5OCA1MC4xMDQ2IDk3LjEwNDYgNTEgOTYgNTFDOTQuODk1NCA1MSA5NCA1MC4xMDQ2IDk0IDQ5VjQxQzk0IDM5Ljg5NTQgOTQuODk1NCAzOSA5NiAzOVpNOTQgNTdDOTQgNTUuODk1NCA5NC44OTU0IDU1IDk2IDU1SDk2LjAyQzk3LjEyNDYgNTUgOTguMDIgNTUuODk1NCA5OC4wMiA1N0M5OC4wMiA1OC4xMDQ2IDk3LjEyNDYgNTkgOTYuMDIgNTlIOTZDOTQuODk1NCA1OSA5NCA1OC4xMDQ2IDk0IDU3WiIgZmlsbD0iI0U1ODMwMyIvPgo8L3N2Zz4K";
export { SvgFilledFeedbackWarning as ReactComponent };